import React, { useEffect, useState } from "react";
import Loader from "../loader/Loader";
import { formatTextWithLineBreaks, getselectedIds, MakeAxiosRequest } from "../../utils/handler";
import { SwalError } from "../SwalFns";
import ServicableAreaImg from "../../Assets/Images/servicableArea.png";
import NonServicableAreaImg from "../../Assets/Images/nonServicableArea.png";
import FormFields from "../inputs/FormFields";
import { FormProvider, useForm } from "react-hook-form";
import ModalBox from "../modals/ModalBox";

function ServiceAreaModal({ showModal, closeModal }) {

  const methods = useForm();
  const { handleSubmit, reset, setValue, watch, trigger, getValues } = methods;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [result, setResult] = useState([]);
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [selectedData, setSelectedData] = useState({
    state: {},
    county: {}
  });

  const stateId = watch("state_id");

  const fetchData = async () => {
    if (stateId) {
      setData((preData) => ({ ...preData, countys: [] }));
      setValue("county_id", "");
    } else {
      setIsLoading(true);
    }

    try {
      const res = await MakeAxiosRequest("post", "/getservicablearea", {
        state_id: stateId || "",
      });

      if (res.status == "1") {
        const states = res.data.states?.map((item) => ({
          id: item.id,
          name: item.state_name,
          prefix: item.state_prefix,
        }));
        const countys = res.data.countys?.map((item) => ({
          id: item.id,
          name: item.county,
        }));
        if(stateId){
          setValue("county",getselectedIds(res.data.countys,'is_selected',1,'county')?.[0] || '');
          setValue("county_id",getselectedIds(res.data.countys,'is_selected',1)?.[0] || '');
          console.log(res.data.countys?.find(op=>op.is_selected=='1'));
          setSelectedData((pre) => ({ ...pre, county: res.data.countys?.find(op=>op.is_selected=='1') }));
        }else{
          setValue("state",getselectedIds(res.data.states,'is_selected',1,'state_name')?.[0] || '');
          setValue("state_id",getselectedIds(res.data.states,'is_selected',1)?.[0] || '');
          console.log(res.data.states?.find(op=>op.is_selected=='1'));
          setSelectedData((pre) => ({ ...pre, state: res.data.states?.find(op=>op.is_selected=='1') }));
        }
        setData({ states, countys: stateId ? countys : [] });
      } else {
        SwalError({ msg: res.message });
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [stateId]);

  const submitServiceAreas = async (data) => {
    setSubmitDisabled(true);

    try {
      // console.log(data);
      const response = await MakeAxiosRequest(
        "post",
        "/updateservicablearea",
        data
      );
      if (response.status == 1) {
        reset();
        if (response.data?.is_servicable_area == 0) {
          setResult(response.data);
          setShowForm(false);
        } else {
          closeModal();
        }
      } else {
        SwalError({ msg: response.message });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
    setSubmitDisabled(false);
  };

  const fields = [
    {
      name: "state",
      label: "State",
      className: "col-12 mb-3",
      rules: { required: "Please select state" },
      type: "popupselect",
      showSearch: true,
      onConfirm: (opt) => {
                // console.log(opt);
                setValue('state_id',opt.id);
                setValue('state',opt.name);
              },
      options: data.states,
      selectedOptionObj: selectedData.state,
      isShow: true,
    },
    {
      name: "county",
      label: "County",
      className: "col-12 mb-3",
      rules: { required: "Please select county" },
      type: "popupselect",
      onConfirm: (opt) => {
                // console.log(opt);
                setValue('county_id',opt.id);
                setValue('county',opt.name);
              },
      showSearch: true,
      options: data.countys,
      selectedOptionObj: selectedData.county,
      isShow: true,
    },
  ];
  return (
    <ModalBox
      isShow={showModal}
      handleClose={closeModal}
      modalSize="md"
      className="modal-bg-disable"
      hideClose={true}
      hasData={true}
    >

    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="col-12 mb-4">
            <div className="row align-items-start">
                {showForm ? (
                  <>
                    <div className="col-12 text-center">
                      <img
                        className="highlightImg"
                        src={ServicableAreaImg}
                        alt="bg-days.png"
                      />
                      <h2 className="mb-md-0">Serviceable Areas</h2>
                      <p>Where will you be primarily ordering services for?</p>
                    </div>
                    <div className="col-12 mt-4">
                      <div className="mx-xxl-2">
                        <FormProvider {...methods}>
                          <form onSubmit={handleSubmit(submitServiceAreas)}>
                            <FormFields fields={fields} />
                            <button
                              className="btn btn-primary rounded-pill w-100 mt-3"
                              type="submit"
                              disabled={isSubmitDisabled}
                            >
                              Continue
                            </button>
                          </form>
                        </FormProvider>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-12 text-center">
                      <img
                        className="highlightImg"
                        src={NonServicableAreaImg}
                        alt="bg-days.png"
                      />
                      <p dangerouslySetInnerHTML={{__html: formatTextWithLineBreaks(result.servicablearea_warning?.description)}}></p>
                    </div>
                    <div className="col-12 mb-3">
                      <div className="mx-xxl-2 text-center">
                        {result.servicablearea_warning?.button_details
                          ?.filter((item) => item.is_show == 1)
                          .map((item, index) =>
                            item.type == "reenter" ? (
                              <button
                                className="btn btn-primary rounded-pill w-100 mt-3"
                                onClick={() => {
                                  setShowForm(true);
                                  reset();
                                  // setIsLoading(true);
                                }}
                              >
                                {item.label}
                              </button>
                            ) : (
                              <a
                                href="javascript:void(0)"
                                className="mt-3 d-block"
                                onClick={closeModal}
                              >
                                {item.label}
                              </a>
                            )
                          )}
                        
                      </div>
                    </div>
                  </>
                )}
              </div>
          </div>
        </>
      )}
    </>
    </ModalBox>
  );
}

export default ServiceAreaModal;
